import wrappedFetch from './base';

const fetchPlans = () => {
  return wrappedFetch('/plans.json')
    .then((response) => response.json());
};

export default fetchPlans;
